<template>
    <v-card flat class="sub-site-wrapper">
        <div v-if="tableStats" class="table-statistics-wrapper">
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="tableStats" class="statistics-text-box elevation-3">
                        <h5>Gesamtzahl der Kampagnen:</h5>
                        <h3>{{ tableStats[0].totalTables }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="tableStats" class="statistics-text-box elevation-3">
                        <h5>Durchschnittliche Leads pro Kampagne:</h5>
                        <h3>{{ tableStats[0].averageLeadsLength.toFixed(2) }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="tableStats" class="statistics-text-box elevation-3">
                        <h5>Median der Leads pro Kampagne:</h5>
                        <h3>{{ tableStats[0].medianLeadsLength }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="tableStats" class="statistics-text-box elevation-3">
                        <h5>Anzahl der in den letzten 30 Tagen erstellten Kampagnen:</h5>
                        <h3>{{ tableStats[0].past30DaysCount }}</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="tableStats" class="statistics-text-box elevation-3">
                        <h5>Anzahl der in den letzten 7 Tagen erstelle Kampagnen:</h5>
                        <h3>{{ tableStats[0].past7DaysCount }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="tableStats" class="statistics-text-box elevation-3">
                        <h5>Durchschnittliche Anzahl der vergebenen Statusfelder:</h5>
                        <h3>{{ tableStats[0].averageStatusLength.toFixed(2) }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="tableStats" class="statistics-text-box elevation-3">
                        <h5>Median der vergebenen Statusfelder:</h5>
                        <h3>{{ tableStats[0].medianStatusLength }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="tableStats" class="statistics-text-box elevation-3">
                        <h5>Anzahl der Kampagnen mit mehr als 150 Leads:</h5>
                        <h3>{{ tableStats[0].moreThan150Leads }}</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="statistics-text-box elevation-3">
                        <h5>Informationen zu den Statistiken:</h5>
                        <p>Es fließen nur Agenturen in die Statistik ein, die eine Stripe Subscription ID besitzen und
                            mindestens einen Slot haben.</p>
                        <p>Die Statistiken wurden am <b>{{ statisticsAge }}</b> erstellt.</p>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
    components: {

    },
    created() {
        this.loadStatistics();
    },
    computed: {
        ...mapState('statistics', ['tableStats', 'loading', 'statisticsAge'])
    },
    methods: {
        ...mapActions('statistics', ['fetchMostRecentStatistic']),
        async loadStatistics() {
            await this.fetchMostRecentStatistic();
        },
    },
}

</script>

<style lang="scss" scoped>
.table-statistics-wrapper {
    padding: 24px;
}


.statistics-text-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-weight: 500;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
    padding: 12px;
}
</style>